import { css } from '@emotion/react'
import { colors } from '@global/constants/colors'

export const fabStyle = css`
  height: 65px;
  width: 65px;
  color: ${colors.gray.light};
  cursor: auto;
`
export const fileCopyOutlinedIconStyle = css`
  font-size: 34px;
  color: ${colors.blue.smokey};
`
export const divStyle = css`
  text-align: center;
  height: 300px;
  padding-top: 100px;
`
